import React from "react";

import { useNavigate } from "react-router-dom";

import HttpError from "commons/utils/errors/HttpError";

export type StateApiErrorType = {
    statusCode: string;
    xRequestId: string;
    method: string;
    url: string;
    status: string;
};

export const makeStateApiError = (error: HttpError): StateApiErrorType => ({
    statusCode: error.responseStatus,
    xRequestId: (error.request.headers as any)["X-Request-ID"],
    method: error.request.method as any,
    url: error.response.url.toString(),
    status: error.responseStatus + " " + error.response.statusText.toString(),
});

function useNavigateToApiErrorPage() {
    let navigate = useNavigate();

    return React.useCallback(
        (error: HttpError) => {
            navigate("/error/api", {
                state: makeStateApiError(error),
            });
        },
        [navigate]
    );
}

export default useNavigateToApiErrorPage;
